import { forwardRef } from 'react';
import cx from 'classnames';
import PropTypes from 'prop-types';

import {
  CUSTOM_BUTTON_COLOR,
  CUSTOM_BUTTON_VARIANT,
  CustomButton,
} from 'src/components/CustomButton';
import { CustomTypography } from 'src/components/CustomTypography';

import { useEvents } from './useEvents';
import { useStyles } from './useStyles';

export const InsightsPanelHint = forwardRef(({ className, style, onNextClick }, ref) => {
  const styles = useStyles();
  const events = useEvents();

  const handleClose = () => {
    events.trackCloseClick();
    onNextClick();
  };

  return (
    <div
      className={cx(styles.root, className)}
      ref={ref}
      style={style}
    >
      <CustomTypography className={styles.title}>
        Ensure High Performance <br />& Brand Alignment
      </CustomTypography>
      <CustomTypography className={styles.description}>
        Anyword&apos;s Insights Panel helps your content perform better, aligns it with your
        audience, and ensures compliance with brand and channel policies.
      </CustomTypography>

      <CustomButton
        className={styles.button}
        variant={CUSTOM_BUTTON_VARIANT.text}
        color={CUSTOM_BUTTON_COLOR.primary}
        data-testid="onboardingInsightsPanelHintButton"
        onClick={handleClose}
      >
        Explore insights
      </CustomButton>
    </div>
  );
});

InsightsPanelHint.propTypes = {
  className: PropTypes.string,
  onNextClick: PropTypes.func.isRequired,
};

InsightsPanelHint.defaultProps = {
  className: null,
};
